
export const translations = {
  en: {
    translation: {
      // General
      learnMore: 'Learn More',
      showMoreButton: 'Show more...',
      showLessButton: 'Okay, I get the point',
      goToTop: 'Go to top',
      clientLogoAlt: 'Client Logo {{number}}',
      toggleLanguage: 'Toggle Language',
      loading: 'Loading...',

      // Header & Nav
      navHome: 'Home',
      navDashboard: 'Dashboard',
      navFeatures: 'Features',
      navPricing: 'Pricing',
      navPlatform: 'Platform',
      navSupport: 'Support',
      navStocks: 'Stocks',
      navNews: 'News',
      navSaraChat: 'Sara AI Chat',
      pageAbout: 'About Us',
      pageBlog: 'Blog',
      signIn: 'Sign In',
      signUp: 'Sign Up',
      signOut: 'Sign Out',
      userProfile: 'User Profile',
      welcomeMessage: 'Welcome, {{name}}',
      createPost: 'Create Post',

      // Auth Modal
      authModalSignInTitle: 'Welcome Back',
      authModalSignUpTitle: 'Create an Account',
      authModalNameLabel: 'Full Name',
      authModalNamePlaceholder: 'Enter your full name',
      authModalPhoneLabel: 'Phone Number (Optional)',
      authModalPhonePlaceholder: 'Enter your phone number',
      authModalEmailLabel: 'Email',
      authModalPasswordLabel: 'Password',
      authModalConfirmPasswordLabel: 'Confirm Password',
      authModalSignInButton: 'Sign In',
      authModalSignUpButton: 'Sign Up',
      authModalOrContinueWith: 'Or continue with',
      authModalGoogleButton: 'Continue with Google',
      authModalAppleButton: 'Continue with Apple',
      authModalExistingAccount: 'Already have an account?',
      authModalNoAccount: "Don't have an account?",
      authModalError: 'An unexpected error occurred. Please try again.',
      authModalPasswordMismatchError: 'Passwords do not match.',

      // Hero Section
      heroSubtitle: 'Saudi Market Intelligence',
      heroTitle: 'Unlock the Saudi Stock Market with AI-Powered Insights',
      heroDescription: 'Leverage institutional-grade AI analysis, real-time data, and predictive insights to make smarter investment decisions on the Saudi Stock Market.',
      heroButton: 'Start Your Free Trial',
      heroDiscoverLivePicks: '👇 Discover Current Opportunities',
      heroStocksMonitored: 'Stocks Under Monitoring',
      heroStatusLive: 'Analysis: Session Live',
      heroStatusClosed: 'Analysis: Waiting for Open',
      heroEntryPointsToday: 'Technical Levels Discovered Today',
      heroEntryPointsRecent: 'Recently Discovered Technical Levels',
      heroOpportunitiesCount: '{{count}} Opportunities',
      heroExpertAskNow: 'Analyze Any Stock with AI Assistant',
      heroExpertTalkNow: 'Talk to the AI Expert Now',

      // Features Section
      featuresSectionSubtitle: 'Our Core Platform',
      featuresSectionTitle: 'Key Features of TAD-AI',
      featuresSectionDescription: 'Our platform is engineered to give you a competitive edge, transforming complex market data into clear, actionable intelligence.',
      feature1Title: 'AI-Powered Market Analytics',
      feature1Desc: 'Access data-driven stock analysis based on advanced quantitative models.',
      feature2Title: 'Real-time Market Data',
      feature2Desc: 'Access up-to-the-second market data, news, and financial statements.',
      feature3Title: 'Portfolio Optimization',
      feature3Desc: 'Analyze and balance your portfolio for optimal risk-reward performance.',
      feature4Title: 'Market Sentiment Analysis',
      feature4Desc: 'Gauge market mood by analyzing news and social media sentiment in real-time.',
      feature5Title: 'Advanced Technical Analysis',
      feature5Desc: 'Utilize a suite of advanced charting tools and indicators for in-depth analysis.',
      feature6Title: 'Customizable Alerts',
      feature6Desc: 'Set personalized alerts for price movements, news, and technical signals.',

      // Feature List Section
      featureListSubtitle1: 'Deep Analysis Engine',
      featureListTitle1: 'Go Beyond the Surface',
      featureListDescription1: 'Our AI engine processes thousands of data points to provide you with comprehensive stock analysis, from fundamental health to technical indicators.',
      featureListTitle2: 'Risk Management Suite',
      featureListDescription2: 'Identify and mitigate potential risks in your portfolio with our AI-powered risk assessment and hedging suggestions.',
      featureListTitle3: 'Seamless Integration',
      featureListDescription3: 'Connect your brokerage account for seamless portfolio tracking and analysis in one unified platform.',

      // Pricing Section
      pricingSectionSubtitle: 'Get access',
      pricingSectionTitle: 'Our Pricing Plan',
      pricingSectionDescription: 'Leverage institutional-grade AI analysis, real-time data, and predictive insights to make smarter investment decisions on the Saudi Stock Market.',
      billingMonthly: 'Monthly',
      billingAnnually: 'Annually',
      billingSave: 'Save ~17%',
      plan1Name: 'Investor',
      plan2Name: 'Pro Trader',
      plan3Name: 'Institutional',
      priceSuffixMonthly: 'EGP/month',
      priceSuffixYearly: 'EGP/year',
      pricingButton: 'Select Plan',
      pricingNoHiddenCharge: 'No extra hidden charges',
      plan1Feature1: 'AI Stock Analytics',
      plan1Feature2: 'Basic Portfolio Analytics',
      plan1Feature3: 'End-of-day Market Data',
      plan1Feature4: 'Standard Charting Tools',
      plan1Feature5: 'Email Support',
      plan2Feature1: 'All Investor Features',
      plan2Feature2: 'Real-time Data & News',
      plan2Feature3: 'Advanced Analytics',
      plan2Feature4: 'Customizable Alerts',
      plan2Feature5: 'Priority Support',
      plan3Feature1: 'All Pro Trader Features',
      plan3Feature2: 'API Access',
      plan3Feature3: 'Sentiment Analysis Engine',
      plan3Feature4: 'Dedicated Account Manager',
      plan3Feature5: 'Team Collaboration Tools',

      // Testimonials
      testimonialsSectionSubtitle: 'Wall of Trust',
      testimonialsSectionTitle: 'What Our Investors Say',
      testimonialsSectionDescription: 'Hear from our community of investors and traders who are leveraging TAD-AI to navigate the market with confidence.',
      testimonial1Name: 'Fahad Al-Saud',
      testimonial1Text1: "TAD-AI has completely changed how I approach the Saudi market. The AI analysis tools are surprisingly thorough and have saved me hours of research.",
      testimonial2Name: 'Noura Al-Jamil',
      testimonial2Text1: "As an experienced trader, I'm impressed by the depth of the technical analysis tools. The real-time data is crucial for my strategy.",
      testimonial2Text2: "The platform is intuitive and powerful. A must-have for serious investors.",
      testimonial3Name: 'Yasir Khan',
      testimonial3Text1: "The portfolio optimization feature helped me rebalance my holdings and significantly improve my risk-adjusted returns. Highly recommended!",
      testimonial4Name: 'Khaled Al-Ghamdi',
      testimonial4Text1: "The sentiment analysis is a game-changer. Understanding market mood gives me an edge I didn't have before. The alerts are also incredibly useful.",
      testimonial5Name: 'Reem Bakr',
      testimonial5Text1: "I started with the Investor plan and quickly upgraded. The value you get is incredible.",
      testimonial5Text2: "Customer support was also very responsive when I had a question.",
      testimonial6Name: 'Sultan Al-Zahrani',
      testimonial6Text1: "Finally, a professional-grade tool built specifically for the Saudi Stock Market. It understands the nuances of our local market.",
      testimonial7Name: 'Lailah Hamad',
      testimonial7Text1: "The insights are clear and actionable. I feel much more confident in my investment decisions since I started using TAD-AI.",
      testimonial8Name: 'Majed Farsi',
      testimonial8Text1: "I've tried many platforms, but TAD-AI's focus on AI-driven analysis sets it apart. The historical data access is extensive and very helpful for backtesting.",
      testimonial9Name: 'Sara Ghaleb',
      testimonial9Text1: "Simple enough for a beginner to understand, yet powerful enough for a pro. The user interface is clean and easy to navigate.",

      // Support Section
      supportSectionSubtitle: 'We are here to help',
      supportSectionTitle: 'Get in Touch With Us',
      supportSectionDescription: 'Have questions about our platform or need assistance? Our team is ready to help you on your investment journey.',
      formNameLabel: 'Your Name',
      formNamePlaceholder: 'John Doe',
      formEmailLabel: 'Your Email',
      formEmailPlaceholder: 'example@domain.com',
      formPhoneLabel: 'Your Phone',
      formPhonePlaceholder: 'e.g., +966 50 123 4567',
      formMessageLabel: 'Your Message',
      formMessagePlaceholder: 'Type your message here...',
      formSendButton: 'Send Message',
      formSubmitting: 'Sending...',
      formSuccessTitle: 'Message Sent!',
      formSuccessMessage: 'Thank you for reaching out. We have received your message and will get back to you shortly.',
      formErrorRequired: 'Please fill out all required fields.',
      formErrorGeneric: 'An error occurred. Please try again later.',
      formErrorSignIn: 'Please sign in to send a message.',

      // Blog Section
      blogSectionSubtitle: 'Latest News & Insights',
      blogSectionTitle: 'From Our Blog',
      blogSectionDescription: 'Stay updated with the latest market trends, platform updates, and investment strategies from the TAD-AI team.',
      blogTagAnalysis: 'Analysis',
      blogTagEnergy: 'Energy Sector',
      blogTagFintech: 'Fintech',
      blogTagAI: 'AI',
      blogTagInvesting: 'Investing',
      blogTagStrategy: 'Strategy',
      blog1Title: 'Unlocking Value in the Saudi Energy Sector with AI',
      blog1Excerpt: 'A deep dive into how our AI models are identifying hidden opportunities in energy stocks.',
      blog1Author: 'Ahmed Al-Mansoori',
      blog2Title: 'The Future of Fintech: How AI is Shaping Investment',
      blog2Excerpt: 'Exploring the intersection of artificial intelligence and financial technology.',
      blog2Author: 'Fatima Al-Harbi',
      blog3Title: 'Developing a Winning Long-Term Investment Strategy',
      blog3Excerpt: 'Key principles for building a resilient portfolio for the long haul in the Saudi market.',
      blog3Author: 'Khalid Al-Ghamdi',

      // CTA Section
      ctaSectionSubtitle: 'Get Started Today',
      ctaSectionTitle: 'Ready to Elevate Your Trading?',
      ctaSectionDescription: 'Join hundreds of investors who are making smarter, data-driven decisions. Sign up for TAD-AI and gain your competitive edge.',
      ctaButton: 'Access Your Dashboard',

      // Footer
      newsletterTitle: 'Stay Ahead of the Market',
      newsletterDescription: 'Subscribe to our newsletter for weekly insights, market analysis, and feature updates.',
      subscribeButton: 'Subscribe',
      footerDescription: 'The leading platform for AI-powered intelligence on the Saudi stock market, providing tools for investors to make informed decisions.',
      footerSiteTitle: 'Site',
      footerMarket: 'Stock Prices',
      footerNews: 'News & Analysis',
      footerFeatures: 'Features',
      footerPricing: 'Pricing',
      footerPlatformTitle: 'Platform',
      footerDashboard: 'Dashboard',
      footerCompanyTitle: 'Company',
      footerAbout: 'About Us',
      footerChangelog: 'Changelog',
      footerLegalTitle: 'Legal & Contact',
      footerTelegramChannel: 'Telegram Channel',
      footerWhatsApp: 'WhatsApp',
      footerPrivacy: 'Privacy Policy',
      footerRefund: 'Refund Policy',
      footerResourcesTitle: 'Resources',
      footerHelp: 'Help Center',
      footerStatus: 'System Status',
      footerReportBug: 'Report a Bug',
      newsletterNote: 'One weekly market digest. No spam — unsubscribe anytime.',
      newsletterSuccess: 'Subscribed! Check your inbox for the next digest.',
      newsletterError: 'Subscription failed. Please try again later.',
      newsletterSubmitting: 'Subscribing…',
      footerCopyright: '© {{year}} TAD-AI. All rights reserved.',

      // Payment Result
      paymentSuccessTitle: 'Payment Successful',
      paymentSuccessMessage: 'Your subscription has been activated successfully! You can now return to the bot to start using Whale recommendations.',
      paymentSuccessButton: 'Return to Trading Bot 🚀',
      paymentFailedTitle: 'Payment Failed',
      paymentFailedMessage: 'Unfortunately, your payment could not be processed. Please try again.',
      paymentFailedRetryButton: 'Try Again',
      paymentFailedSupportButton: 'Contact Tech Support',

      // Footer Bots
      footerTelegramBotsTitle: 'Our Bots',
      footerBotGeneral: 'Free Public Bot (TAD AI)',
      footerBotVip: 'Technical Alerts Bot',
      footerBotSupport: 'Tech Support',

      // Market Status & Holidays
      marketStatusLive: 'Live Liquidity Monitoring 🐋',
      marketStatusHoliday: 'Official Holiday',
      marketStatusResting: 'AI in Analysis Mode 💤',
      marketConnectedText: 'TAD-AI system is now connected directly to the market! Processing institutional liquidity and real-time market momentum.',
      marketClosedHolidayText: 'The market is closed due to: <strong>{{reason}}</strong>. Waiting for trading to resume!',
      marketClosedRestingText: 'The market is closed. AI is now processing today\'s data to prepare tomorrow\'s expected opportunities.',
      holidayBannerText: 'The Saudi Market is closed today for: ',
      holidayReasonDefault: 'Official Holiday',

      // Live AI Picks
      livePicksSubtitle: 'AI Smart-Liquidity Monitor',
      livePicksTitle: 'Most Active Stocks 🐋',
      livePicksDescription: 'A read of smart-liquidity flow. Visitor figures are delayed by 15 minutes — live data is reserved for subscribers.',
      livePicksUnknownStock: 'Unknown',
      livePicksCurrentPrice: 'Current Price',
      livePicksSmartLiquidity: 'Smart Liquidity',
      livePicksPromptTitle: 'Want to explore all market data and technical levels?',
      livePicksPromptDesc: 'This is a sample delayed by 15 minutes. Subscribe to follow liquidity and momentum alerts the moment they happen.',
      livePicksSubscribeBtn: 'Upgrade Now',
      feedDelayed: 'Delayed 15 minutes · last update {{time}}',
      feedClose: 'Market closed · last close {{time}}',
      feedWaiting: 'Waiting for the first delayed update of this session…',
      feedSubscribersOnly: 'Live analysis is for subscribers only',

      // News pulse widget
      newsPulseTitle: 'Latest News',
      newsPulseSubtitle: 'Published automatically every session by the TAD-AI news engine',
      newsPulseAll: 'All news',
      newsPulseNew: 'New',

      // Market Stats
      marketStatsTitle: 'A Deeper Look at the Market Pulse 📊',
      marketStatsDesc: 'Follow the top 10 stocks by gain and smart liquidity. Visitor figures are delayed 15 minutes and refresh automatically.',
      marketStatsGainers: 'Top Gainers',
      marketStatsLiquidity: 'Smart Liquidity Centers (Whales)',
      marketStatsCurrency: 'SAR',

      // AI Floating Widget
      aiWidgetReqRec: 'Analyze a Stock Now',
      aiWidgetSubVip: 'Upgrade Plan',
      aiWidgetFreeChan: 'Free Channel',
      aiWidgetOpen: 'AI Assistant',
      footerDisclaimerTitle: 'Financial & Legal Disclaimer',
      footerDisclaimerText: 'TAD-AI is a market intelligence and quantitative technology platform providing data analytics and technical indicators for the Saudi Stock Market (TASI) for research, informational, and educational purposes only. TAD-AI is not an authorized financial advisor and does not provide personal financial advice or direct buy/sell recommendations. All market models and analytics are subject to market risks, and any investment decisions are made solely at the user\'s own discretion and responsibility.'
    },
  },
  ar: {
    translation: {
      // General
      learnMore: 'اعرف المزيد',
      showMoreButton: 'عرض المزيد...',
      showLessButton: 'حسنًا، فهمت',
      goToTop: 'اذهب للأعلى',
      clientLogoAlt: 'شعار العميل {{number}}',
      toggleLanguage: 'تبديل اللغة',
      loading: 'جاري التحميل...',

      // Header & Nav
      navHome: 'الرئيسية',
      navDashboard: 'لوحة التحكم',
      navFeatures: 'المميزات',
      navPricing: 'الأسعار',
      navPlatform: 'المنصة',
      navSupport: 'الدعم',
      navStocks: 'الأسهم',
      navNews: 'الأخبار',
      navSaraChat: 'سارة (Sara AI)',
      pageAbout: 'من نحن',
      pageBlog: 'المدونة',
      signIn: 'تسجيل الدخول',
      signUp: 'إنشاء حساب',
      signOut: 'تسجيل الخروج',
      userProfile: 'ملف المستخدم',
      welcomeMessage: 'أهلاً، {{name}}',
      createPost: 'إنشاء منشور',

      // Auth Modal
      authModalSignInTitle: 'أهلاً بعودتك',
      authModalSignUpTitle: 'إنشاء حساب جديد',
      authModalNameLabel: 'الاسم الكامل',
      authModalNamePlaceholder: 'أدخل اسمك الكامل',
      authModalPhoneLabel: 'رقم الجوال (اختياري)',
      authModalPhonePlaceholder: 'أدخل رقم جوالك',
      authModalEmailLabel: 'البريد الإلكتروني',
      authModalPasswordLabel: 'كلمة المرور',
      authModalConfirmPasswordLabel: 'تأكيد كلمة المرور',
      authModalSignInButton: 'تسجيل الدخول',
      authModalSignUpButton: 'إنشاء حساب',
      authModalOrContinueWith: 'أو المتابعة باستخدام',
      authModalGoogleButton: 'المتابعة باستخدام جوجل',
      authModalAppleButton: 'المتابعة باستخدام أبل',
      authModalExistingAccount: 'لديك حساب بالفعل؟',
      authModalNoAccount: 'ليس لديك حساب؟',
      authModalError: 'حدث خطأ غير متوقع. الرجاء المحاولة مرة أخرى.',
      authModalPasswordMismatchError: 'كلمتا المرور غير متطابقتين.',

      // Hero Section
      heroSubtitle: 'ذكاء السوق السعودي',
      heroTitle: 'اكتشف سوق الأسهم السعودي برؤى مدعومة بالذكاء الاصطناعي',
      heroDescription: 'استفد من تحليل الذكاء الاصطناعي المؤسسي والبيانات الفورية والرؤى التنبؤية لاتخاذ قرارات استثمارية أكثر ذكاءً في تداول.',
      heroButton: 'ابدأ تجربتك المجانية',
      heroDiscoverLivePicks: '👇 اكتشف الفرص الحالية',
      heroStocksMonitored: 'الأسهم تحت المراقبة',
      heroStatusLive: 'حالة التحليل: جلسة جارية',
      heroStatusClosed: 'حالة التحليل: ينتظر الافتتاح',
      heroEntryPointsToday: 'المستويات الفنية المرصودة اليوم',
      heroEntryPointsRecent: 'المستويات الفنية المرصودة مؤخراً',
      heroOpportunitiesCount: '{{count}} فرصة',
      heroExpertAskNow: 'استفسر عن تحليل سهم من المساعد الذكي',
      heroExpertTalkNow: 'تحدث مع الخبير الآلي الآن',

      // Features Section
      featuresSectionSubtitle: 'منصتنا الأساسية',
      featuresSectionTitle: 'الميزات الرئيسية لـ TAD-AI',
      featuresSectionDescription: 'تم تصميم منصتنا لمنحك ميزة تنافسية، وتحويل بيانات السوق المعقدة إلى معلومات استخباراتية واضحة وقابلة للتنفيذ.',
      feature1Title: 'تحليلات ذكية ومؤشرات متقدمة',
      feature1Desc: 'احصل على قراءات وبيانات تفصيلية للأسهم تعتمد على نماذج إحصائية متطورة.',
      feature2Title: 'بيانات السوق في الوقت الفعلي',
      feature2Desc: 'الوصول إلى بيانات السوق والأخبار والبيانات المالية محدثة كل ثانية.',
      feature3Title: 'تحسين المحفظة الاستثمارية',
      feature3Desc: 'حلل وازن محفظتك لتحقيق الأداء الأمثل من حيث المخاطر والمكافآت.',
      feature4Title: 'تحليل معنويات السوق',
      feature4Desc: 'قم بقياس مزاج السوق من خلال تحليل الأخبار ومشاعر وسائل التواصل الاجتماعي في الوقت الفعلي.',
      feature5Title: 'تحليل فني متقدم',
      feature5Desc: 'استخدم مجموعة من أدوات الرسوم البيانية والمؤشرات المتقدمة لتحليل متعمق.',
      feature6Title: 'تنبيهات قابلة للتخصيص',
      feature6Desc: 'قم بإعداد تنبيهات مخصصة لتحركات الأسعار والأخبار والإشارات الفنية.',

      // Feature List Section
      featureListSubtitle1: 'محرك التحليل العميق',
      featureListTitle1: 'تجاوز السطح',
      featureListDescription1: 'يعالج محرك الذكاء الاصطناعي لدينا آلاف نقاط البيانات ليوفر لك تحليلاً شاملاً للأسهم، من الصحة الأساسية إلى المؤشرات الفنية.',
      featureListTitle2: 'مجموعة إدارة المخاطر',
      featureListDescription2: 'حدد المخاطر المحتملة في محفظتك وقم بتخفيفها من خلال تقييم المخاطر واقتراحات التحوط المدعومة بالذكاء الاصطناعي.',
      featureListTitle3: 'تكامل سلس',
      featureListDescription3: 'اربط حساب الوساطة الخاص بك لتتبع وتحليل المحفظة بسلاسة في منصة واحدة موحدة.',

      // Pricing Section
      pricingSectionSubtitle: 'احصل على الوصول',
      pricingSectionTitle: 'خطة الأسعار لدينا',
      pricingSectionDescription: 'استفد من تحليل الذكاء الاصطناعي المؤسسي والبيانات الفورية والرؤى التنبؤية لاتخاذ قرارات استثمارية أكثر ذكاءً في تداول.',
      billingMonthly: 'شهري',
      billingAnnually: 'سنوي',
      billingSave: 'وفر ~١٧٪',
      plan1Name: 'مستثمر',
      plan2Name: 'متداول محترف',
      plan3Name: 'مؤسسي',
      priceSuffixMonthly: 'جنيه/شهر',
      priceSuffixYearly: 'جنيه/سنة',
      pricingButton: 'اختر الخطة',
      pricingNoHiddenCharge: 'لا توجد رسوم خفية إضافية',
      plan1Feature1: 'تحليلات أسهم بالذكاء الاصطناعي',
      plan1Feature2: 'تحليلات أساسية للمحفظة',
      plan1Feature3: 'بيانات السوق عند الإغلاق',
      plan1Feature4: 'أدوات رسم بياني قياسية',
      plan1Feature5: 'دعم عبر البريد الإلكتروني',
      plan2Feature1: 'جميع ميزات المستثمر',
      plan2Feature2: 'بيانات وأخبار في الوقت الفعلي',
      plan2Feature3: 'تحليلات متقدمة',
      plan2Feature4: 'تنبيهات قابلة للتخصيص',
      plan2Feature5: 'دعم ذو أولوية',
      plan3Feature1: 'جميع ميزات المتداول المحترف',
      plan3Feature2: 'وصول لواجهة برمجة التطبيقات (API)',
      plan3Feature3: 'محرك تحليل المشاعر',
      plan3Feature4: 'مدير حساب مخصص',
      plan3Feature5: 'أدوات تعاون الفريق',

      // Testimonials
      testimonialsSectionSubtitle: 'جدار الثقة',
      testimonialsSectionTitle: 'ماذا يقول مستثمرونا',
      testimonialsSectionDescription: 'استمع إلى مجتمعنا من المستثمرين والمتداولين الذين يستفيدون من منصة TAD-AI للتنقل في السوق بثقة.',
      testimonial1Name: 'فهد آل سعود',
      testimonial1Text1: "لقد غيرت منصة TAD-AI تمامًا طريقة تعاملي مع السوق السعودي. أدوات التحليل بالذكاء الاصطناعي متطورة بشكل مدهش وقد وفرت لي ساعات من البحث.",
      testimonial2Name: 'نورة الجميل',
      testimonial2Text1: "كمتداولة ذات خبرة، أنا معجبة بعمق أدوات التحليل الفني. البيانات الفورية حاسمة لاستراتيجيتي.",
      testimonial2Text2: "المنصة بديهية وقوية. لا غنى عنها للمستثمرين الجادين.",
      testimonial3Name: 'ياسر خان',
      testimonial3Text1: "ساعدتني ميزة تحسين المحفظة في إعادة توازن ممتلكاتي وتحسين عوائدي المعدلة حسب المخاطر بشكل كبير. موصى به بشدة!",
      testimonial4Name: 'خالد الغامدي',
      testimonial4Text1: "تحليل المشاعر يغير قواعد اللعبة. فهم مزاج السوق يمنحني ميزة لم أكن أمتلكها من قبل. التنبيهات مفيدة للغاية أيضًا.",
      testimonial5Name: 'ريم بكر',
      testimonial5Text1: "بدأت بخطة المستثمر وقمت بالترقية بسرعة. القيمة التي تحصل عليها لا تصدق.",
      testimonial5Text2: "كان دعم العملاء أيضًا سريع الاستجابة عندما كان لدي سؤال.",
      testimonial6Name: 'سلطان الزهراني',
      testimonial6Text1: "أخيرًا، أداة احترافية مصممة خصيصًا لتداول. إنها تفهم الفروق الدقيقة في سوقنا المحلي.",
      testimonial7Name: 'ليلى حمد',
      testimonial7Text1: "الرؤى واضحة وقابلة للتنفيذ. أشعر بثقة أكبر في قراراتي الاستثمارية منذ أن بدأت استخدام منصة TAD-AI.",
      testimonial8Name: 'ماجد الفارسي',
      testimonial8Text1: "لقد جربت العديد من المنصات، لكن تركيز منصة TAD-AI على التحليل المدفوع بالذكاء الاصطناعي يميزه. الوصول إلى البيانات التاريخية واسع ومفيد جدًا للاختبار الخلفي.",
      testimonial9Name: 'سارة غالب',
      testimonial9Text1: "بسيطة بما يكفي ليفهمها المبتدئ، لكنها قوية بما يكفي للمحترفين. واجهة المستخدم نظيفة وسهلة التنقل.",

      // Support Section
      supportSectionSubtitle: 'نحن هنا للمساعدة',
      supportSectionTitle: 'تواصل معنا',
      supportSectionDescription: 'هل لديك أسئلة حول منصتنا أو تحتاج إلى مساعدة؟ فريقنا مستعد لمساعدتك في رحلتك الاستثمارية.',
      formNameLabel: 'اسمك',
      formNamePlaceholder: 'جون دو',
      formEmailLabel: 'بريدك الإلكتروني',
      formEmailPlaceholder: 'example@domain.com',
      formPhoneLabel: 'رقم هاتفك',
      formPhonePlaceholder: 'مثال: +966 50 123 4567',
      formMessageLabel: 'رسالتك',
      formMessagePlaceholder: 'اكتب رسالتك هنا...',
      formSendButton: 'إرسال الرسالة',
      formSubmitting: 'جار الإرسال...',
      formSuccessTitle: 'تم إرسال الرسالة!',
      formSuccessMessage: 'شكراً لتواصلك معنا. لقد استلمنا رسالتك وسنعاود الاتصال بك قريباً.',
      formErrorRequired: 'يرجى ملء جميع الحقول المطلوبة.',
      formErrorGeneric: 'حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقاً.',
      formErrorSignIn: 'يرجى تسجيل الدخول لإرسال رسالة.',

      // Blog Section
      blogSectionSubtitle: 'آخر الأخبار والرؤى',
      blogSectionTitle: 'من مدونتنا',
      blogSectionDescription: 'ابق على اطلاع بآخر اتجاهات السوق وتحديثات المنصة واستراتيجيات الاستثمار من فريق TAD-AI.',
      blogTagAnalysis: 'تحليل',
      blogTagEnergy: 'قطاع الطاقة',
      blogTagFintech: 'تكنولوجيا مالية',
      blogTagAI: 'ذكاء اصطناعي',
      blogTagInvesting: 'استثمار',
      blogTagStrategy: 'استراتيجية',
      blog1Title: 'إطلاق القيمة في قطاع الطاقة السعودي بالذكاء الاصطناعي',
      blog1Excerpt: 'نظرة متعمقة على كيفية تحديد نماذج الذكاء الاصطناعي لدينا للفرص الخفية في أسهم الطاقة.',
      blog1Author: 'أحمد المنصوري',
      blog2Title: 'مستقبل التكنولوجيا المالية: كيف يشكل الذكاء الاصطناعي الاستثمار',
      blog2Excerpt: 'استكشاف التقاطع بين الذكاء الاصطناعي والتكنولوجيا المالية.',
      blog2Author: 'فاطمة الحربي',
      blog3Title: 'تطوير استراتيجية استثمار طويلة الأجل ناجحة',
      blog3Excerpt: 'مبادئ أساسية لبناء محفظة مرنة على المدى الطويل في السوق السعودي.',
      blog3Author: 'خالد الغامدي',

      // CTA Section
      ctaSectionSubtitle: 'ابدأ اليوم',
      ctaSectionTitle: 'هل أنت مستعد للارتقاء بتداولاتك؟',
      ctaSectionDescription: 'انضم إلى مئات المستثمرين الذين يتخذون قرارات أكثر ذكاءً تعتمد على البيانات. سجل في منصة TAD-AI واكتسب ميزتك التنافسية.',
      ctaButton: 'ادخل إلى لوحة التحكم',

      // Footer
      newsletterTitle: 'ابق متقدماً على السوق',
      newsletterDescription: 'اشترك في نشرتنا الإخبارية للحصول على رؤى أسبوعية وتحليلات السوق وتحديثات الميزات.',
      subscribeButton: 'اشتراك',
      footerDescription: 'المنصة الرائدة للذكاء الاصطناعي في سوق الأسهم السعودي، وتوفر أدوات للمستثمرين لاتخاذ قرارات مستنيرة.',
      footerSiteTitle: 'الموقع',
      footerMarket: 'أسعار الأسهم',
      footerNews: 'الأخبار والتحليلات',
      footerFeatures: 'المميزات',
      footerPricing: 'الباقات',
      footerPlatformTitle: 'المنصة',
      footerDashboard: 'لوحة التحكم',
      footerCompanyTitle: 'الشركة',
      footerAbout: 'من نحن',
      footerChangelog: 'سجل التحديثات',
      footerLegalTitle: 'قانوني وتواصل',
      footerTelegramChannel: 'قناة تيليجرام',
      footerWhatsApp: 'واتساب',
      footerPrivacy: 'سياسة الخصوصية',
      footerRefund: 'سياسة الاسترداد',
      footerResourcesTitle: 'المصادر',
      footerHelp: 'مركز المساعدة',
      footerStatus: 'حالة النظام',
      footerReportBug: 'الإبلاغ عن خطأ',
      newsletterNote: 'ملخص أسبوعي واحد للسوق، بدون إزعاج — يمكنك إلغاء الاشتراك في أي وقت.',
      newsletterSuccess: 'تم الاشتراك ✓ سيصلك الملخص القادم على بريدك.',
      newsletterError: 'تعذّر إتمام الاشتراك، جرّب مرة أخرى بعد قليل.',
      newsletterSubmitting: 'جارٍ الاشتراك…',
      footerCopyright: '© {{year}} تاد-ايه اي. جميع الحقوق محفوظة.',

      // Payment Result
      paymentSuccessTitle: 'دفع ناجح',
      paymentSuccessMessage: 'تم تفعيل اشتراكك بنجاح! يمكنك العودة للبوت الآن لبدء استخدام أدوات التحليل ورصد السيولة.',
      paymentSuccessButton: 'العودة للمنصة 🚀',
      paymentFailedTitle: 'فشل الدفع',
      paymentFailedMessage: 'عذرًا، لم نتمكن من معالجة عملية الدفع الخاصة بك. يرجى المحاولة مرة أخرى.',
      paymentFailedRetryButton: 'المحاولة مرة أخرى',
      paymentFailedSupportButton: 'تواصل مع الدعم الفني',

      // Footer Bots
      footerTelegramBotsTitle: 'بوتاتنا',
      footerBotGeneral: 'البوت المجاني العام',
      footerBotVip: 'بوت التنبيهات والتحليلات',
      footerBotSupport: 'الدعم الفني',

      // Market Status & Holidays
      marketStatusLive: 'رصد حي للسيولة 🐋',
      marketStatusHoliday: 'إجازة رسمية',
      marketStatusResting: 'الذكاء الاصطناعي في وضع التحليل 💤',
      marketConnectedText: 'نظام <strong>TAD-AI</strong> متصل الآن بالسوق مباشرة! يرصد تدفقات السيولة ومستويات الزخم اللحظي بدقة.',
      marketClosedHolidayText: 'السوق مغلق بناءً على مجريات: <strong>{{reason}}</strong>. نترقب عودة التداول!',
      marketClosedRestingText: 'السوق مغلق. الذكاء الاصطناعي يقوم الآن بمعالجة بيانات اليوم لتحضير الفرص المتوقعة للغد.',
      holidayBannerText: 'السوق السعودي مغلق اليوم بمناسبة: ',
      holidayReasonDefault: 'إجازة رسمية',

      // Live AI Picks
      livePicksSubtitle: 'رصد السيولة الذكية بالذكاء الاصطناعي',
      livePicksTitle: 'أقوى الشركات نشاطاً 🐋',
      livePicksDescription: 'قراءة لحركة السيولة الذكية في السوق. أرقام الزوار متأخرة 15 دقيقة — والبيانات اللحظية مخصصة للمشتركين.',
      livePicksUnknownStock: 'غير معروف',
      livePicksCurrentPrice: 'السعر الحالي',
      livePicksSmartLiquidity: 'السيولة الذكية',
      livePicksPromptTitle: 'هل تريد استكشاف كافة البيانات والمستويات الفنية؟',
      livePicksPromptDesc: 'هذه عينة متأخرة 15 دقيقة. اشترك في الباقة المتقدمة لتحصل على حركة السيولة وتنبيهات الزخم لحظة بلحظة.',
      livePicksSubscribeBtn: 'ترقية الاشتراك الآن',
      feedDelayed: 'متأخر 15 دقيقة · آخر تحديث {{time}}',
      feedClose: 'السوق مغلق · آخر إغلاق {{time}}',
      feedWaiting: 'بانتظار أول تحديث متأخر لهذه الجلسة…',
      feedSubscribersOnly: 'التحليل اللحظي متاح للمشتركين فقط',

      // News pulse widget
      newsPulseTitle: 'آخر الأخبار',
      newsPulseSubtitle: 'تُنشر تلقائياً كل جلسة عبر محرك أخبار TAD-AI',
      newsPulseAll: 'كل الأخبار',
      newsPulseNew: 'جديد',

      // Market Stats
      marketStatsTitle: 'نظرة أعمق على نبض السوق 📊',
      marketStatsDesc: 'تابع أقوى 10 أسهم من حيث الارتفاع والسيولة الذكية. أرقام الزوار متأخرة 15 دقيقة وتتحدث تلقائياً خلال الجلسة.',
      marketStatsGainers: 'قائمة الأكثر ارتفاعاً',
      marketStatsLiquidity: 'مراكز السيولة الذكية (الحيتان)',
      marketStatsCurrency: '﷼',

      // AI Floating Widget
      aiWidgetReqRec: 'حلل سهمك الآن',
      aiWidgetSubVip: 'ترقية الاشتراك',
      aiWidgetFreeChan: 'القناة المجانية',
      aiWidgetOpen: 'مساعد السوق',
      footerDisclaimerTitle: 'إخلاء المسؤولية المالية والقانونية',
      footerDisclaimerText: 'منصة TAD-AI هي منصة تقنية متخصصة في تحليل البيانات الإحصائية والمؤشرات الفنية لسوق الأسهم السعودي (تاسي) لأغراض البحث والتحليل الفني والتعليمي فقط. المنصة لا تقدم أي استشارات مالية أو استثمارية، ولا تصدر توصيات مباشرة بالشراء أو البيع لأي أوراق مالية. كافة التحليلات والنماذج الرياضية تعتمد على بيانات السوق العامة وتخضع لتقلبات ومخاطر الأسواق المالية، وقرار التداول يقع على عاتق المستخدم بالكامل.'
    }
  }
};
